// ProjectInfo.jsx
import React, { useState } from "react";
import "./ProjectInfo.css";

const ProjectInfo = () => {
  const [activeTab, setActiveTab] = useState("Task List");

  const tabs = [
    "Overview",
    "Comments",
    "Task List",
    "Events",
    "Board",
    "Sprint",
    "Gantt",
    "Building Block",
    "Team",
    "Ticket",
    "Resource Allocation",
    "Commercials",
    "Workflow",
    "Partner",
    "Milestones",
  ];

  const developmentTasks = [
    {
      name: "Update Log Fields in all Tables",
      assignee: "",
      dueDate: "3/9/26",
      priority: "Medium",
    },
    {
      name: "Update OS source in payout header and payout item table",
      assignee: "",
      dueDate: "3/31/26",
      priority: "Medium",
    },
    {
      name: "Scheme Uploads in Wrong Combinations",
      assignee: "",
      dueDate: "4/3/26",
      priority: "High",
    },
    {
      name: "Check one Login cache issue",
      assignee: "",
      dueDate: "Jan 20, 26",
      priority: "Medium",
    },
  ];

  const noStageTasks = [
    {
      name: "Check one Login cache issue",
      assignee: "",
      dueDate: "Jan 20, 26",
      priority: "Medium",
    },
    {
      name: "Check one Login cache issue",
      assignee: "",
      dueDate: "Jan 20, 26",
      priority: "Low",
    },
  ];

  const getPriorityClass = (priority) => {
    switch (priority) {
      case "High":
        return "priority-high";
      case "Medium":
        return "priority-medium";
      case "Low":
        return "priority-low";
      default:
        return "priority-medium";
    }
  };

  return (
    <div className="pm-container">
      {/* Header */}
      <div className="pm-header">
        <div className="pm-title-section">
          <div className="pm-title-bar"></div>
          <div>
            <h1 className="pm-title">Scheme Automation - CRDec25</h1>
            <p className="pm-monitoring">
              MONITORING 24 ACTIVE HIGH-PRIORITY DELIVERABLES
            </p>
          </div>
        </div>
      </div>

      {/* Tabs */}
      <div className="pm-tabs-wrapper">
        <div className="pm-tabs">
          {tabs.map((tab, index) => (
            <button
              key={index}
              className={`pm-tab ${activeTab === tab ? "pm-tab-active" : ""}`}
              onClick={() => setActiveTab(tab)}
            >
              {tab}
            </button>
          ))}
        </div>
      </div>

      {/* Action Buttons */}
      <div className="pm-actions">
        <button className="pm-btn-primary">+ ADD TASK</button>
        <button className="pm-btn-secondary">+ ADD STAGE</button>
      </div>

      {/* Development Section */}
      <div className="pm-table-section">
        <div className="pm-table-header">
          <div className="pm-table-title-wrapper">
            <div className="pm-table-indicator"></div>
            <span className="pm-table-title">Development</span>
          </div>
          <div className="pm-task-count">4 tasks</div>
        </div>
        <table className="pm-table">
          <thead>
            <tr>
              <th className="pm-col-name">NAME</th>
              <th className="pm-col-assignee">ASSIGNEE</th>
              <th className="pm-col-date">DUE DATE</th>
              <th className="pm-col-priority">PRIORITY</th>
            </tr>
          </thead>
          <tbody>
            {developmentTasks.map((task, index) => (
              <tr key={index} className="pm-table-row">
                <td className="pm-cell-name">
                  <div className="pm-task-name-cell">
                    <span className="pm-play-icon">▶</span>
                    <span className="pm-check-icon">✓</span>
                    <span className="pm-task-text">{task.name}</span>
                  </div>
                </td>
                <td className="pm-cell-assignee">
                  <div className="pm-avatar-placeholder"></div>
                </td>
                <td className="pm-cell-date">{task.dueDate}</td>
                <td className="pm-cell-priority">
                  <div
                    className={`pm-priority ${getPriorityClass(task.priority)}`}
                  >
                    <span className="pm-flag-icon">⚑</span>
                    {task.priority}
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* No Stage Assigned Section */}
      <div className="pm-table-section">
        <div className="pm-table-header">
          <div className="pm-table-title-wrapper">
            <div className="pm-table-indicator"></div>
            <span className="pm-table-title">No Stage Assigned</span>
          </div>
          <div className="pm-task-count">2 tasks</div>
        </div>
        <table className="pm-table">
          <thead>
            <tr>
              <th className="pm-col-name">NAME</th>
              <th className="pm-col-assignee">ASSIGNEE</th>
              <th className="pm-col-date">DUE DATE</th>
              <th className="pm-col-priority">PRIORITY</th>
            </tr>
          </thead>
          <tbody>
            {noStageTasks.map((task, index) => (
              <tr key={index} className="pm-table-row">
                <td className="pm-cell-name">
                  <div className="pm-task-name-cell">
                    <span className="pm-play-icon">▶</span>
                    <span className="pm-check-icon">✓</span>
                    <span className="pm-task-text">{task.name}</span>
                  </div>
                </td>
                <td className="pm-cell-assignee">
                  <div className="pm-avatar-placeholder"></div>
                </td>
                <td className="pm-cell-date">{task.dueDate}</td>
                <td className="pm-cell-priority">
                  <div
                    className={`pm-priority ${getPriorityClass(task.priority)}`}
                  >
                    <span className="pm-flag-icon">⚑</span>
                    {task.priority}
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ProjectInfo;
